import { ALLOW_PREDEFINED_VALUES, assertsValidAllow } from '../constant';

import { getAttributeArray, getAttributeFromArray } from './attrs';

export const ALLOW_DELIMITER = ';';

export const getAllow = (allow: string | undefined) => {
    if (!allow) {
        return getAttributeFromArray(ALLOW_PREDEFINED_VALUES, ALLOW_DELIMITER);
    }

    const allowArr = getAttributeArray(allow, assertsValidAllow, ALLOW_DELIMITER);

    return getAttributeFromArray([...allowArr, ...ALLOW_PREDEFINED_VALUES], ALLOW_DELIMITER);
};

export const testUtils = {
    isAllowIncludesPredefinedValues: (allow: string) => ALLOW_PREDEFINED_VALUES.every((val) => allow.includes(val)),
};
